export const HOST = {
    TRACK_HOST: window.jdy_config.track_log_host,
    WEBSOCKET_SITE: window.jdy_config.websocket_site,
    HELP_HOST: window.jdy_config.help_site,
    VIDEO_HOST: `${window.jdy_config.assets_endpoint}/app/resource/video`
};

// 导航栏组件
export enum NAV_COMPONENT {
    DOCK = 'dock', // 工作台切换按钮
    MENU = 'menu', // 切换工作台/知识管理/通讯录/知识库
    BROWSER = 'browser', // 浏览器打开
    MESSAGE = 'message', // 消息中心
    PROFILE = 'profile', // 个人中心
    CONTACTS = 'contacts' // 通讯录
}

// 进入重置密码页时的状态
export const PWD_RESET_STATUS = {
    // 忘记密码时进入重置密码页
    FORGET_PASSWORD: 'forget_password',
    // 密码过期时进入重置密码页
    PASSWORD_EXPIRED: 'password_expired',
    // 密码规则修改后提示当前密码无效时进入重置密码页
    INVALID_PASSWORD_FORMAT: 'invalid_password_format'
};

export const PASSWORD_REG = {
    // 密码长度
    PASSWORD_LENGTH: /^.{8,30}$/,
    // 包含数字
    INCLUDE_NUMBER: /[0-9]/,
    // 包含大写字母
    INCLUDE_UPPERCASE: /[A-Z]/,
    // 包含小写字母
    INCLUDE_LOWERCASE: /[a-z]/,
    // 包含特殊字符
    INCLUDE_CHARACTER: /.*[!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/].*/,
    // 密码是否符合数字、大写字母、小写字母及特殊字符，至少包含上述字符中的三种
    STANDARD:
        /(^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/])[A-Za-z\d!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/]{3,}$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/])[A-Za-z!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/]{3,}$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{3,}$)/,
    // 密码是否符合数字、大写字母、小写字母及特殊字符，至少包含上述字符中的三种，且长度为8-30位
    REQUIREMENT:
        /(^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/])[A-Za-z\d!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/]{8,30}$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/])[A-Za-z!@#$%^&*()_+\-={}|\[\]\\:";'<>?,.\/]{8,30}$)|(^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,30}$)/
};

export const TEXT_TYPE_REGEXP = {
    // 手机号码
    MOBILE: '^((\\(\\d{2,3}\\))|(\\d{3}\\-))?1\\d{10}$',
    // 电话号码
    TEL: '^(0[0-9]{2,3}\\-)?([2-9][0-9]{6,7})+(\\-[0-9]{1,4})?$',
    // 邮政编码
    ZIP: '^\\d{6}$',
    // 18位身份证
    ID: '^(1[1-9]|8[0-2]|[2-7]\\d)\\d{4}[1-9]\\d{3}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])\\d{3}(\\d|X)$',
    // 国际手机号码
    INTER_MOBILE: '^\\+?(\\d{1,4}-)?\\d{7,}$',
    // 电子邮箱
    EMAIL: '^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$',
    // 统一社会信用代码
    SOCIAL_CREDIT_CODE: '^[0-9A-HJ-NPQRTUWXY]{2}\\d{6}[0-9A-HJ-NPQRTUWXY]{10}$',
    // 超链接
    URL: '(?:http(?:s)?:\\/\\/|www)[\\w.]+(?:[-\\w.,!|?=%:&/+#~@]*[-\\w|?=%:&/+#~@])+',
    // 以 http 或 https 开头的严格url
    STRICT_URL: '^https?:\\/\\/[-a-zA-Z0-9@:%._+~#=]{2,256}\\b([-a-zA-Z0-9@:%_+.~#?&\\/=]*)',
    // 成员编号
    USERNAME: '^[\\w\\.]{1,70}$'
};

export const MAX_UPLOAD_FILE_SIZE = 5 * 1024 * 1024;
// 允许自定义图标上传最大图片大小，20M
export const MAX_ICON_SIZE = 20 * 1024 * 1024;

// 固定链接地址
export const LINK = {
    // 技术支持
    TECHNICAL_SUPPORT_LINK: window.jdy_config.link.technical_support_link,
    // 商务咨询
    BUSINESS_SUPPORT_LINK: `${window.jdy_config.link.technical_support_link}?source=business`,
    /** 自建插件 - 用户协议 */
    PLUGIN_AGREEMENT: window.jdy_config.link.private_plugin_usage_agreement,
    // 开放平台需求反馈
    OPEN_PLATFORM_DEMAND_FEEDBACK: `${window.jdy_config.link.open_platform_feedback_link}`,
    // 系统管理员申请
    SYS_ADMIN_APPLY_LINK: window.jdy_config.link.sys_admin_apply_link,
    // AI 能力设置
    AI_LAB: window.jdy_config.link.ai_lab
};

// 互联组织
export enum COLLABORATOR_MENU_TYPE {
    CORP = 'corp',
    DOCKER = 'docker'
}

/** 默认分页大小 */
export const DEFAULT_PAGINATION_SIZE = 20;

// 通讯录跨页勾选最大支持勾选数量
export const CONTACT_CHECKED_MAX = 5000;

export const PARAMETER = {
    EMPTY: 'fx_param_empty'
};

// 拖拽距离，拖拽超过5px，认为拖拽
export const DRAG_DISTANCE = 5;

/** 链接跳转的target */
export const WIN_TARGET = {
    /** 新标签页 */
    NEW: '_blank',
    /** 帮助文档 */
    DOC: 'jdy_doc'
};

/** 静态资源路径前缀 */
export const STATIC_ASSETS_PATH_PREFIX =
    PLATFORM_ENV === 'true' ? '/plat_static/platform/pc' : '/static/platform/pc';

export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
export const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
